import { httpClient } from "../../httpClient";

const apiUrl = "/api";

export const penaltyTypeApi = {
  reorder: (clubId: number, order: { id: number; sort_order: number }[]) =>
    httpClient(`${apiUrl}/penalties/types/reorder?club_id=${clubId}`, {
      method: "POST",
      body: JSON.stringify(order),
    }),
};

export async function fetchPublicPenaltyTypes(clubId: number) {
  const { json } = await httpClient(`${apiUrl}/penalties/types/public?club_id=${clubId}`);
  return (json?.data ?? []);
}

export function penaltiesResource(clubId: number | null) {
  return {
    types: {
      getList: async () => {
        if (!clubId) return { data: [], total: 0 };
        const { json } = await httpClient(`${apiUrl}/penalties/types?club_id=${clubId}`);
        const data = json?.data ?? [];
        return { data, total: json?.total ?? data.length };
      },
      getOne: async (params: any) => {
        const { json } = await httpClient(`${apiUrl}/penalties/types/${params.id}`);
        return { data: json };
      },
      create: async (params: any) => {
        const { json } = await httpClient(`${apiUrl}/penalties/types`, {
          method: "POST",
          body: JSON.stringify({ ...params.data, club_id: params.data.club_id ?? clubId }),
        });
        return { data: json };
      },
      update: async (params: any) => {
        const { json } = await httpClient(`${apiUrl}/penalties/types/${params.id}`, {
          method: "PUT",
          body: JSON.stringify({ ...params.data, club_id: params.data.club_id ?? clubId }),
        });
        return { data: json };
      },
      delete: async (params: any) => {
        await httpClient(`${apiUrl}/penalties/types/${params.id}`, { method: "DELETE" });
        return { data: { id: params.id } };
      },
    },

    penalties: {
      getList: async (params: any) => {
        if (!clubId) return { data: [], total: 0 };
        const qs = new URLSearchParams();
        qs.set("club_id", String(clubId));
        const page = params?.pagination?.page ?? 1;
        const perPage = params?.pagination?.perPage ?? 50;
        qs.set("page", String(page));
        qs.set("perPage", String(perPage));
        if (params?.filter?.player_id) qs.set("player_id", String(params.filter.player_id));
        if (params?.filter?.status) qs.set("status", params.filter.status);
        const { json } = await httpClient(`${apiUrl}/penalties?${qs.toString()}`);
        const data = json?.data ?? [];
        return { data, total: json?.total ?? data.length };
      },
      create: async (params: any) => {
        const { json } = await httpClient(`${apiUrl}/penalties`, {
          method: "POST",
          body: JSON.stringify({ ...params.data, club_id: params.data.club_id ?? clubId }),
        });
        return { data: json };
      },
      update: async (params: any) => {
        const { json } = await httpClient(`${apiUrl}/penalties/${params.id}`, {
          method: "PATCH",
          body: JSON.stringify(params.data),
        });
        return { data: json ?? { ...params.previousData, ...params.data } };
      },
      delete: async (params: any) => {
        const reason: string | undefined = params.meta?.reason;
        await httpClient(`${apiUrl}/penalties/${params.id}`, {
          method: "DELETE",
          body: reason ? JSON.stringify({ reason }) : JSON.stringify({}),
        });
        return { data: { id: params.id } };
      },
    },
  };
}

export async function fetchMyPenalties(clubId: number) {
  const { json } = await httpClient(`${apiUrl}/penalties/my?club_id=${clubId}`);
  return (json?.data ?? []);
}
